import { Box, Grid, IconSuccess24, Text } from '@stitch-fix/mode-react';
import { Header, type HeaderProps } from '../Header';
import styles from './style.module.scss';
export type PrimaryObjectivesHighlightedProps = {
  blocks: {
    title: string;
    description: string;
  }[];
  headerProps?: HeaderProps;
  hideIcon?: boolean;
};
export const PrimaryObjectivesHighlighted = ({
  blocks,
  headerProps,
  hideIcon
}: PrimaryObjectivesHighlightedProps) => <Box className={styles.wrapper}>
    {headerProps && <Header {...headerProps} />}
    <Box className={styles.container}>
      <Grid columns={{
      lg: 4,
      sm: 1
    }} spacing="none">
        {blocks.map(block => <Box className={styles.block} key={block.title}>
            {!hideIcon && <Box className={styles.icon}>
                <IconSuccess24 color="default" purpose="decorative" title="Checkmark" key={block.title} />
              </Box>}
            <Box mb={0.5}>
              <Text family="medium" height="standard" scale="3">
                {block.title}
              </Text>
            </Box>
            <Text setting="body-small" dangerouslySetInnerHTML={{
          __html: block.description
        }} />
          </Box>)}
      </Grid>
    </Box>
  </Box>;